import { useInvalidateQueries } from '@partful/shared/lib/hooks/useInvalidateQueries';
import { useProductInventory } from '@partful/shared/lib/hooks/useProductInventory';
import { POSTPartsCategoriesIngestResponse, productInventoryEndpoints } from '@services/productInventory';
import { useMutation } from '@tanstack/react-query';

export interface UseCreatePartCategoriesIngestVars {
  runID: string;
  accountId: string;
}

export const useCreatePartCategoriesIngest = () => {
  const { invalidateContentProcessingJobsQueries } = useInvalidateQueries();

  const { getService } = useProductInventory();

  return useMutation<POSTPartsCategoriesIngestResponse, Error, UseCreatePartCategoriesIngestVars>({
    mutationFn: async ({ runID, accountId }) => {
      const productInventoryService = await getService();

      return (
        await productInventoryService.post(
          `${productInventoryEndpoints.contentProcessing.partsCategories}/${runID}/start-ingest?account=${accountId}`
        )
      ).data.payload;
    },
    onSuccess: async () => {
      await invalidateContentProcessingJobsQueries();
    },
  });
};
